import PropTypes from 'prop-types';
import {Todo} from 'front-onceforall-core';
import {Collapse} from '@material-ui/core';
import Message from './message';
import Actions from './actions';

const icon = {
  USER_PENDING: 'user-plus',
  RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'message',
  RELATIONSHIP_SUGGESTED: 'message',
  PROJECT_NOT_AUTOMATICALLY_ACCEPTED: 'project'
};

function InvitationView(props) {
  const {invitation} = props;

  return (
    <Collapse in={!invitation.isHidden}>
      <Todo
        icon={icon[invitation.type]}
        message={<Message invitation={invitation}/>}
        creationDate={invitation.creationDate}
      >
        <Actions
          isSuggestion={props.isSuggestion}
          invitation={invitation}
          onAccept={props.onAccept}
          onReject={props.onReject}
          canAddUser={props.canAddUser}
        />
      </Todo>
    </Collapse>
  );
}

InvitationView.defaultProps = {
  isSuggestion: false
};

InvitationView.propTypes = {
  invitation: PropTypes.object.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  canAddUser: PropTypes.bool,
  isSuggestion: PropTypes.bool
};

export default InvitationView;
